import { render } from "./UpdateSection.vue?vue&type=template&id=72427991"
import script from "./UpdateSection.vue?vue&type=script&lang=js"
export * from "./UpdateSection.vue?vue&type=script&lang=js"

import exportComponent from "/home/tek2991/Desktop/Works/Projects/NEW_EPMS/avant-director-production/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__